<template>
  <fragment v-if="value && value.$error">
    <div
      class="form-generator__error"
      v-for="(param, index) in value.$params"
      :key="index"
    >
      <div v-show="param && param.type && !value[param.type]">
        {{ showErrorByType(param) }}
      </div>
    </div>
  </fragment>
</template>

<script>
const errorText = {
  required: () => 'Field is required',
  requiredIf: () => 'Field is required',
  minLength: (param) => `Min Length ${param.min}`,
  email: () => 'Invalid email',
  maxValue: (param, field, allFields) => {
    // Check if this is the carry-over field by checking the field name
    if (field && field.name === 'max_days_can_move_to_next_year') {
      return "Can't be more than max days per year"
    }
    return `Can't be more than ${param.max}`
  }
}

export default {
  name: 'ErrorMessage',
  props: {
    value: {
      type: [Object, null],
      default: null
    },
    field: {
      type: Object,
      default: null
    },
    allFields: {
      type: Object,
      default: null
    }
  },
  methods: {
    showErrorByType (param) {
      if (!param || !param.type || !errorText[param.type]) {
        return 'Field is required'
      }
      return errorText[param.type](param, this.field, this.allFields)
    }
  }
}
</script>
